export enum PreselectionDatePickerType {
    TODAY = 'today',
    LAST_24_HOURS = 'last24hours',
    LASTWEEK = 'lastweek',
    LAST_MONTH = 'lastmonth',
    LAST_3_MONTH = 'last3months',
    LAST_CUSTOM_DAYS = 'lastCustomDays',
    CUSTOM = 'custom'
}
